<template>
  <v-card class="ma-2">
    <v-data-table dense :headers="headers" :items="locationlist">
      <template v-slot:top>
        <v-layout row wrap class="mb-2">
          <v-row class="mt-3">
            <v-col cols="3">
              <v-card-title class="primary--text">
                Locations
                <v-divider vertical class="ml-5 mx-0"></v-divider>
              </v-card-title>
            </v-col>
            <v-spacer />
            <v-col cols="4" class="mt-2">
              <v-text-field
                v-model="search"
                shaped
                outlined
                dense
                class="mt-n1"
                color="primary"
                append-icon="mdi-magnify"
                label="Search"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="mt-2 mr-4">
              <v-dialog
                persistent
                v-model="AddLocation"
                class="overflow-hidden"
                width="1000"
              >
                <v-toolbar dark class="gradient-bg2">
                  <v-toolbar-items>
                    <v-toolbar-title class="white--text titcss ml-3 mt-4"
                      >Add Location</v-toolbar-title
                    >
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-btn text dark @click="AddLocation = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <template #activator="{ on: AddLocation }">
                  <v-tooltip bottom color="primary">
                    <template #activator="{ on: tooltip }">
                      <v-btn
                        class="primary white--text"
                        v-on="{ ...AddLocation, ...tooltip }"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span class="white--text">Add a New Location</span>
                  </v-tooltip>
                </template>
                <v-card class="overflow-hidden">
                  <v-divider></v-divider>
                  <v-row>
                    <v-col md="6" class="ma-3 mr-n5">
                      <GmapMap
                        :center="startlocation"
                        :zoom="20"
                        map-type-id="terrain"
                        style="width: 500px; height: 300px"
                      >
                        <GmapMarker
                          :key="index"
                          v-for="(m, index) in markers"
                          :position="m.position"
                          :clickable="true"
                          :draggable="true"
                          @click="center = m.position"
                        />
                      </GmapMap>
                    </v-col>
                    <v-col md="6">
                      <v-form ref="form">
                        <v-row class="mt-8 mx-7">
                          <v-text-field
                            v-model="Name"
                            label="Location Name *"
                            color="primary"
                            required
                            outlined
                            dense
                          ></v-text-field>
                        </v-row>
                        <v-row class="ml-1">
                          <v-col md="10">
                            <gmap-autocomplete
                              placeholder="Search Location"
                              :value="search"
                              class="ml-5"
                              ref="clearSearch"
                              style="
                                border-bottom: 1px solid grey;
                                font-size: 18px;
                                width: 300px;
                              "
                              @place_changed="setPlace"
                            ></gmap-autocomplete>
                          </v-col>
                          <v-col md="1" class="ml-n5">
                            <v-btn
                              rounded
                              small
                              class="white--text"
                              color="primary"
                              @click="addMarker"
                              >Go</v-btn
                            >
                          </v-col>
                        </v-row>
                        <v-row class="mx-7">
                          <v-textarea
                            v-model="Address"
                            color="primary"
                            label="Address *"
                            required
                            outlined
                            dense
                          ></v-textarea>
                        </v-row>
                        <v-row class="mr-7 mb-8">
                          <v-spacer></v-spacer>
                          <v-card-actions>
                            <v-btn
                              class="primary mr-n2 white--text"
                              :loading="isLoading"
                              medium
                            >
                              <v-icon class="mr-2 ml-n2">mdi-plus</v-icon>Add
                              Location
                            </v-btn>
                          </v-card-actions>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>

                  <v-card-actions></v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-layout>
      </template>
    </v-data-table>
  </v-card>
</template>
 <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY_HERE&libraries=places"></script>

<script>
// import { apiCall } from "@/Views/APICALL/APIcall.js";
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
  components: { VueGoogleAutocomplete },
  data: () => ({
    AddLocation: false,
    search: "",
    isLoading: false,
    Address: "",
    Name: "",
    Description: "",
    markers: [],
    startlocation: {
      lat: 80,
      lng: 90,
    },
    getdepartmentlist: [],
    headers: [
      {
        text: "Location Name",
        value: "name",
      },
      {
        text: "Address",
        value: "Address",
      },
      {
        text: "Created On",
        value: "created_on",
      },
      {
        text: "Actions",
        value: "Actions",
      },
    ],
    locationlist: [
      {
        name: "Mobil80",
        Address: "vidyaranyapura, india",
        created_on: "25-02-2021",
      },
    ],
  }),
  mounted() {
    // this.getdepartment();
    //   console.log("marksers", this.markers);
  },
  methods: {
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      //   console.log("currplace", this.currentPlace);
      if (this.currentPlace) {
        var marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        var add = this.currentPlace.formatted_address;
        this.Address = add;
        //console.log("marker", marker);

        this.startlocation.lat = marker.lat;
        this.startlocation.lng = marker.lng;

        this.markers.push({ position: marker });

        // this.startlocation = { lat: marker.lat, lng: marker.lng };
        //    console.log("sadsadsadasdssads", this.startlocation);

        // (this.latt = marker.lat), (this.longg = marker.lng);
        // console.log("asdasdasdasdasdasdasdas", this.latt);
      }
    },
  },
  //   methods: {
  //     async createDepartment() {
  //       var inputData = {
  //         method_name: "CORPONBOARD",
  //         page_no: 0,
  //         record_count: 0,
  //         page_size: 25,
  //         app_code: "CPORTAL",
  //         method_param: {
  //           action: "DEPMASTER",
  //           department_id: 5,
  //           department_name: this.Name,
  //           department_description: this.Description,
  //           corp_id: 1,
  //         },
  //       };
  //       var responseData = await apiCall(inputData);
  //       this.deplist = responseData;
  //       console.log("post address", this.deplist);
  //       // this.getbankinfo();
  //     },
  //     async getdepartment() {
  //       var inputData = {
  //         method_name: "CORPONBOARD",
  //         page_no: 0,
  //         record_count: 0,
  //         page_size: 25,
  //         app_code: "CPORTAL",
  //         method_param: {
  //           action: "GDMASTER",
  //           corp_id: 1,
  //         },
  //       };
  //       var responseData = await apiCall(inputData);
  //       this.getdepartmentlist = responseData.data.data;
  //       console.log("depdata", this.getdepartmentlist);
  //     },
  //   },
};
</script>

<style>
</style>